<lms-breadcrumb [label]="client?.name"></lms-breadcrumb>

<ng-container *ngIf="!noStudents">
  <lms-toolbar [options]="toolbarConfig">
    <div class="lms-toolbar__item" *lmsProfileGuard="'students.create'">
      <span class="lmstooltip">
        <lms-button-select
          [isDisabled]="!canAddStudents"
          [title]="'students.manage'"
          [text]="'students.manage'"
          [tooltip]="
            !canAddStudents
              ? !client.subscriptions.users
                ? ('students.subscriptionCheck.noActiveSubscription' | translate) +
                  ' / ' +
                  ('students.noCreditsTooltip' | translate)
                : ('students.subscriptionCheck.noActiveSubscription' | translate) +
                  ' / ' +
                  ('students.noSeatsTooltip' | translate)
              : ''
          "
          [tooltipLeft]="true"
        >
          <li>
            <a [routerLink]="['/students/new']" [queryParams]="{ clientId: client?.id }">{{
              'students.addOne' | translate
            }}</a>
          </li>
          <li>
            <a [routerLink]="['/students/import']" [queryParams]="{ clientId: client?.id }">{{
              'students.addList' | translate
            }}</a>
          </li>
          <li *lmsProfileGuard="'students.importCsv'">
            <a (click)="openCsvModal()">{{ 'students.addCsv' | translate }}</a>
          </li>
          <li *lmsProfileGuard="'students.changeEmailBulk'">
            <a (click)="openCsvModal(true)">{{ 'students.changeEmailBulk' | translate }}</a>
          </li>
          <li *ngIf="canInvite">
            <a [routerLink]="['/students/invite']" [queryParams]="{ clientId: client?.id }">{{
              'students.invite.title' | translate
            }}</a>
          </li>
        </lms-button-select>
      </span>
    </div>
  </lms-toolbar>

  <lms-students-list [showActions]="showActions" [selectable]="true" [listId]="listId" [options]="options">
  </lms-students-list>
</ng-container>

<!-- client without students -->
<div *ngIf="noStudents">
  <div class="main__void">
    <div class="main__void--icon">
      <span class="glicon-student"></span>
    </div>
    <span class="main__void--title">{{ 'students.notStudentsTitle' | translate }}</span>
    <span class="main__void--subtitle">{{ 'students.notStudentsSubTitle' | translate }}</span>
    <span class="lmstooltip">
      <lms-button-select
        [title]="'students.add'"
        [text]="'students.add'"
        [isDisabled]="!canAddStudents"
        [tooltip]="
          !canAddStudents
            ? !client.subscriptions.users
              ? ('students.subscriptionCheck.noActiveSubscription' | translate) +
                ' / ' +
                ('students.noCreditsTooltip' | translate)
              : ('students.subscriptionCheck.noActiveSubscription' | translate) +
                ' / ' +
                ('students.noSeatsTooltip' | translate)
            : ''
        "
      >
        <li>
          <a [routerLink]="['/students/new']" [queryParams]="{ clientId: client?.id }">{{
            'students.addOne' | translate
          }}</a>
        </li>
        <li>
          <a [routerLink]="['/students/import']" [queryParams]="{ clientId: client?.id }">{{
            'students.addList' | translate
          }}</a>
        </li>
        <li *lmsProfileGuard="'students.importCsv'">
          <a (click)="openCsvModal()">{{ 'students.addCsv' | translate }}</a>
        </li>
        <li *ngIf="canInvite">
          <a [routerLink]="['/students/invite']" [queryParams]="{ clientId: client?.id }">{{
            'students.invite.title' | translate
          }}</a>
        </li>
      </lms-button-select>
    </span>
  </div>
</div>

<lms-modal #modalCsvSelectClient size="small">
  <div class="gl-popup__title">{{ 'students.addCsvStudents' | translate }}</div>
  <div class="gl-popup__close" (click)="closeCsvModalCorporate()">
    <span class="glicon-close"></span>
  </div>
  <div>
    <div class="gl-popup__text">
      {{ 'students.selectClientCsvStudents' | translate }}
    </div>
  </div>
  <div class="gl-popup__form">
    <lms-dynamic-form
      [questions]="questions"
      [options]="{ submitLabel: 'nouns.goNext', showSpinnerUponSubmitting: false, disableCard: true }"
      (submit)="setClient($event)"
    >
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="closeCsvModalCorporate()"
        form-actions-before
      ></gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>

<lms-modal #modalCsvUpload size="medium">
  <lms-csv-import
    #downloadcCsvExample
    [isEmailChange]="isEmailChangeCsv"
    (closeModal)="closeCsvModal()"
    (onSaveCsvData)="onSaveCsv($event)"
  ></lms-csv-import>
</lms-modal>
